<script lang="ts">
	import type { HTMLAttributes } from "svelte/elements";
	import { getTranslate } from "../utils/getTranslate.js";
	import translation from "./RecaptchaDisclaimer.translations.json" with { type: "json" };
	import Formatted from "./common/Formatted.svelte";

	const all: Omit<HTMLAttributes<HTMLDivElement>, "children"> = $props();
	const translate = getTranslate(translation);
</script>

<div
	{...all}
	class={["font-medium text-center tracking-[0.02em] text-xs/normal uppercase md:text-sm/[1.2] mt-1", all.class]}
>
	<Formatted text={translate("disclaimer")} />
</div>
